import { route, SandboxError, type Route } from '../adapter';
import { matches, newId, now } from '../store';
import type { Charity, CharityWrite } from '@/lib/charities';

/** The charity directory. */
export const charityRoutes: readonly Route[] = [
  route('GET', '/charities', ({ store, query }) => {
    const status = query.get('status');
    return { data: store.charities.filter((charity) => (status && status !== 'all' ? charity.status === status : true)).filter((charity) => matches(query.get('search'), charity.name, charity.regions.map((region) => `${region.city ?? ''} ${region.state ?? ''}`).join(' '), charity.contacts.map((contact) => contact.name).join(' '))) };
  }),
  route('GET', '/charities/:id', ({ store, params }) => {
    const charity = store.charities.find((row) => row._id === params['id']);
    if (!charity) throw new SandboxError(404, 'Charity not found.');
    return { data: charity };
  }),
  route('POST', '/charities', ({ store, body }) => {
    const write = body as CharityWrite;
    const charity: Charity = { ...write, causeTags: write.causeTags ?? [], regions: write.regions ?? [], contacts: write.contacts ?? [], status: write.status ?? 'pending', _id: newId(), history: [], updatedAt: now() };
    store.charities = [...store.charities, charity];
    return { data: charity };
  }),
  route('PATCH', '/charities/:id', ({ store, params, body }) => {
    const index = store.charities.findIndex((row) => row._id === params['id']);
    const existing = store.charities[index];
    if (!existing) throw new SandboxError(404, 'Charity not found.');
    const updated: Charity = { ...existing, ...(body as Partial<CharityWrite>), updatedAt: now() };
    store.charities[index] = updated;
    return { data: updated };
  }),
  route('DELETE', '/charities/:id', ({ store, params }) => {
    store.charities = store.charities.filter((row) => row._id !== params['id']);
    return { data: null };
  }),
];
